export const IconX = ({ width = 40, height = 40, color = 'var(--violet)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.000488281' width={width} height={height} rx='20' fill={color} />
    <path
      d='M13.125 13.7505H14.6875L24.0625 26.2505H22.5L13.125 13.7505ZM15.9375 13.7505H17.5L26.875 26.2505H25.3125L15.9375 13.7505Z'
      fill='#FAFAFC'
    />
    <path
      d='M14.375 13.7505H17.5V15.0005H14.375V13.7505ZM22.5 26.2505H25.625V25.0005H22.5V26.2505Z'
      fill='#FAFAFC'
    />
    <path
      d='M24.0625 13.7505H26.25L15.625 26.2505H13.4375L24.0625 13.7505Z'
      fill='#FAFAFC'
    />
  </svg>
);
